import { createOAuthDatabase, type OAuthDatabase } from './store';

export let CLIENT_ID: string;
export let REDIRECT_URI: string;

export let database: OAuthDatabase;

export interface ConfigureOAuthOptions {
	metadata: {
		client_id: string;
		redirect_uri: string;
	};
	/**
	 * Prefix used for the localStorage keys that persist authentication state.
	 * @default "atcute-oauth"
	 */
	storageName?: string;
}

let configured = false;

export const configureOAuth = (options: ConfigureOAuthOptions) => {
	({ client_id: CLIENT_ID, redirect_uri: REDIRECT_URI } = options.metadata);
	database = createOAuthDatabase({ name: options.storageName ?? 'atcute-oauth' });
	configured = true;
};

export const isOAuthConfigured = () => configured;
